import { Box, Card, Skeleton } from '@mui/material';
import { colors } from '@src/styles';
import { profileCardSX, skeletonColor } from '../profileStyles';

export const ProfileInfoCardSkeleton = () => {
  return (
    <Card elevation={0} sx={{ ...profileCardSX, height: { xs: 'auto', md: 340 }, padding: 2.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, marginBottom: 2 }}>
        <Skeleton
          variant="rounded"
          width={32}
          height={32}
          sx={{ backgroundColor: skeletonColor, borderRadius: '9px' }}
        />
        <Skeleton variant="text" width={70} height={22} sx={{ backgroundColor: skeletonColor }} />
      </Box>
      {[0, 1, 2, 3].map((item) => (
        <Box
          key={item}
          sx={{
            display: 'flex',
            gap: 1.5,
            paddingY: 1.25,
            borderTop: item === 0 ? 'none' : `1px solid ${colors.brand.line}`,
            paddingTop: item === 0 ? 0 : 1.25,
          }}
        >
          <Skeleton variant="circular" width={18} height={18} sx={{ backgroundColor: skeletonColor }} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={80} height={14} sx={{ backgroundColor: skeletonColor }} />
            <Skeleton
              variant="text"
              width={item === 0 ? '75%' : '35%'}
              height={20}
              sx={{ backgroundColor: skeletonColor }}
            />
          </Box>
        </Box>
      ))}
    </Card>
  );
};
